var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconTrendingUp48Line = function SvgIconTrendingUp48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.79 16.18c-.56-.56-1.32-.87-2.12-.85l-8.77.21.08 3.4 5.73-.14-6.77 6.77-3.8-3.8c-.66-.66-1.74-.66-2.4 0l-8 8 2.4 2.4 6.8-6.8 3.8 3.8c.66.66 1.74.66 2.4 0l8.03-8.03-.14 5.84 3.4.08.21-8.77c.02-.79-.29-1.56-.85-2.12v.01Z",
    fill: "current"
  })));
};
export default SvgIconTrendingUp48Line;